import _ from 'lodash';
import BaseCtrl from 'edge/platform/base/BaseCtrl';

const fn = ($filter, $scope, $state, $q, $stateParams, ModalService, ServiceRequestService, ViewModelService, $window, httpSettings) => {
    const ctrl = Object.create(BaseCtrl);
    let _serviceRequestInvoiceForm;

    ctrl.init = () => {
        $scope.documentNotFoundURL = `${$window.location.pathname.substring(0, window.location.pathname.lastIndexOf('/'))}/ServiceRequestDocumentError`;
        $scope.claimCenterDownloadURI = `${httpSettings.serviceBaseURLs.cc}document/document/claimDocument`;
        $scope.serviceRequest = $state.current.data.serviceRequest;
        $scope.tableConfig = {
            attachingDocuments: false,
            paginationSize: 1000
        };

        const invoice = $state.current.data.invoice ||
            {
                totalAmount: {},
                existingDocumentsToLink: []
            };

        $scope.invoiceView = ViewModelService.create(invoice, 'cc', 'edge.capabilities.servicerequest.statement.invoice.dto.ServiceRequestInvoiceDTO');

        $scope.$watch('invoiceView.existingDocumentsToLink.length', (newLength, oldLength) => {
            if (oldLength !== newLength) {
                if (_serviceRequestInvoiceForm) {
                    _serviceRequestInvoiceForm.$setValidity('noDocuments', !!(newLength));
                }
            }
        });
    };

    ctrl.addInvoice = (serviceRequestInvoiceForm) => {
        _serviceRequestInvoiceForm = serviceRequestInvoiceForm;

        if ($scope.invoiceView.existingDocumentsToLink.length === 0) {
            serviceRequestInvoiceForm.submitted = true;
            serviceRequestInvoiceForm.$setValidity('noDocuments', false);
            return;
        }
        serviceRequestInvoiceForm.$setValidity('noDocuments', true);

        serviceRequestInvoiceForm.submitted = true;

        if (serviceRequestInvoiceForm.$valid && $scope.invoiceView.aspects.subtreeValid) {
            // Associate existing documents from the service request.
            $scope.invoiceView.existingDocumentsToLink.value = _.map($scope.invoiceView.existingDocumentsToLink.value, 'publicID');

            $scope.submitInvoicePromise = ServiceRequestService.addInvoice($scope.serviceRequest.publicID, $scope.invoiceView.value).then(
                () => {
                    $state.transitionTo($state.$current.data.actions.serviceRequestDetails, {
                        serviceRequestNumber: $scope.serviceRequest.serviceRequestNumber,
                        tab: 'invoices'
                    });
                },
                (error) => {
                    ModalService.showError(
                        'servicerequest.controllers.InvoiceDetailsCtrl.Adding invoice failed',
                        $q.when(error)
                    );
                }
            );
        }
    };

    ctrl.getReferenceNumber = () => {
        return $scope.invoiceView.referenceNumber.value ? $scope.invoiceView.referenceNumber.value : '';
    };

    ctrl.goToServiceRequest = () => {
        if ($scope.serviceRequest) {
            $state.transitionTo($state.$current.data.actions.serviceRequestDetails, {
                serviceRequestNumber: $scope.serviceRequest.serviceRequestNumber,
                tab: 'invoices'
            });
        } else {
            // global invoices
            $state.transitionTo($state.$current.data.actions.invoices);
        }

    };

    return ctrl.create($scope);
};
fn.$inject = ['$filter', '$scope', '$state', '$q', '$stateParams', 'ModalService', 'servicerequest.ServiceRequestService', 'ViewModelService', '$window', 'httpSettings'];
export default fn;
